import './Heading-22c9c83c.css';

var classes = {"ActionListHeader":"prc-ActionList-ActionListHeader-lEr8v"};

export { classes as default };
